import styleFn, {compose} from '../util'

const border = styleFn({
  propName: 'border'
})

const borderColor = styleFn({
  propName: 'borderColor',
  systemProp: 'colors'
})

const borderStyle = styleFn({
  propName: 'borderStyle'
})

const borderRadius = styleFn({
  propName: 'borderRadius'
})

const directions = ['Top', 'Bottom', 'Left', 'Right']
const withBorder = dir => 'border' + dir
const getStyle = propName => styleFn({propName})
const borderDirections = directions.map(withBorder).map(getStyle)

export default compose(
  border,
  borderRadius,
  borderColor,
  borderStyle,
  ...borderDirections
)
